import ROUTE_CONSTANTS from "./route-constants";

export const routesByEntity: Record<string, (id: number) => string> = {
    CONTENT: (id: number) => ROUTE_CONSTANTS.CONTENT_MANAGEMENT.CONTENTS.SHOW.SHOW_BY_ID(id).ABSOLUTE,
    AVATAR: () => ROUTE_CONSTANTS.MEDIA_MANAGEMENT.AVATARS.ROOT.ABSOLUTE,
    PROFILE: () => ROUTE_CONSTANTS.MEDIA_MANAGEMENT.AVATARS.ROOT.ABSOLUTE,
};
